// import { PoweroffOutlined } from '@ant-esign/icons';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaFont, FaSun } from 'react-icons/fa';

import FloatingButton from '../floatingButton';
// import classes from './style/AccessibilityButton.module.css';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IAccessibilityButtonProps {
  exa?: string;
  toggleTheme: () => void;
  changeFontSize: () => void;
}

const AccessibilityButton: React.FunctionComponent<
  IAccessibilityButtonProps
> = (props) => {
  // TOOLS
  const { t } = useTranslation();

  // PROPS
  const { toggleTheme, changeFontSize } = props;

  // STATE

  // SELECTORS

  const actions = [
    {
      label: t('accessibility.fontSize'),
      icon: <FaFont />,
      onClick: changeFontSize
    }
    // {
    //   label: t('accessibility.contract'),
    //   icon: <FaSun />,
    //   onClick: toggleTheme
    // }
  ];

  // VIEW
  return <FloatingButton actions={actions} />;
};

export default AccessibilityButton;
